import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

// Modal de geração de pagamento (antes script inline em shared/pagamentos/_botao).
// Abre o .modal (singleton), injeta o form (de um <template>), preenche os campos
// e os dados de favorecido/pagador, e trata o submit via fetch + swal + Turbo.
export default class extends Controller {
  static targets = ["template"]
  static values = {
    origemType: String,
    origemId: String,
    url: String,
    instituicaoId: String,
    lancamentoId: String,
    valor: String,
    obs1: String,
    hasFavorecido: Boolean,
    favorecido: Object,
    hasPagador: Boolean,
    pagador: String
  }

  open(event) {
    event.preventDefault()

    const origemType = this.origemTypeValue
    const origemId = this.origemIdValue
    const urlPost = this.urlValue
    const instituicaoId = this.instituicaoIdValue
    const lancamentoId = this.lancamentoIdValue

    document.querySelector(".modal").classList.add("is-active")
    const modalContent = document.querySelector(".modal-content")
    modalContent.innerHTML = this.templateTarget.innerHTML
    modalContent.style.width = "40%"

    setTimeout(() => {
      const valorInput = document.querySelector("input[name='valor']")
      valorInput.focus()
      valorInput.value = this.valorValue
      document.querySelector("input[name='observacao_1']").value = this.obs1Value
    }, 100)

    document.querySelector("input[name='resource_type']").value = origemType
    document.querySelector("input[name='resource_id']").value = origemId
    document.querySelector("input[name='url']").value = urlPost
    document.querySelector("input[name='instituicao_id']").value = instituicaoId
    document.querySelector("input[name='lancamento_id']").value = lancamentoId

    if (this.hasFavorecidoValue) {
      const f = this.favorecidoValue
      document.querySelector("#favorecido_documento").textContent = f.documento
      document.querySelector("#favorecido_nome").textContent = f.nome
      document.querySelector("#favorecido_endereco").textContent = f.endereco
      document.querySelector("#favorecido_bairro").textContent = f.bairro
      document.querySelector("#favorecido_cep").textContent = f.cep
      document.querySelector("#favorecido_cidade").textContent = f.cidade
      document.querySelector("#favorecido_uf").textContent = f.uf
      document.querySelector("#dados_bancarios").textContent = f.dados_bancarios
    } else {
      document.querySelector("#box-favorecido").style.display = "none"
    }

    if (this.hasPagadorValue) {
      document.querySelector("#box-pagador").style.display = ""
      document.querySelector("#pagador").textContent = this.pagadorValue
    } else {
      document.querySelector("#box-pagador").style.display = "none"
    }

    document.querySelector("#gerarPagamento").addEventListener("click", (e) => {
      e.preventDefault()
      const observacao_1 = document.querySelector("input[name='observacao_1']").value
      const observacao_2 = document.querySelector("input[name='observacao_2']").value
      const observacao_3 = document.querySelector("input[name='observacao_3']").value
      const descontar_taxa_ted = document.querySelector("#descontar_taxa_ted").checked
      const valor = document.querySelector("input[name='valor']").value

      const montaParametros = {}
      montaParametros["resource_type"] = origemType
      montaParametros["resource_id"] = origemId
      montaParametros["observacao_1"] = observacao_1
      montaParametros["observacao_2"] = observacao_2
      montaParametros["observacao_3"] = observacao_3
      montaParametros["descontar_taxa_ted"] = descontar_taxa_ted
      montaParametros["valor"] = valor
      montaParametros["instituicao_id"] = instituicaoId
      montaParametros["lancamento_id"] = lancamentoId

      document.querySelector("#gerarPagamento").textContent = "Gerando pagamento, aguarde..."
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const body = new URLSearchParams()
      Object.entries(montaParametros).forEach(function (entry) {
        body.append("pagamento[" + entry[0] + "]", entry[1])
      })

      fetch(urlPost, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body
      })
        .then((response) => {
          if (!response.ok) throw new Error("HTTP " + response.status)
          return response.json()
        })
        .then((data) => {
          if (!data.ok) {
            setTimeout(function () {
              Swal.fire({ title: data.titulo, text: data.mensagem, icon: "error", confirmButtonText: "OK" })
              document.querySelector("#gerarPagamento").textContent = "Gerar!"
            }, 300)
            return
          }
          setTimeout(function () {
            Swal.fire({ title: data.titulo, text: data.mensagem, icon: "success", confirmButtonText: "OK" })
              .then(function () {
                document.querySelector(".modal").classList.remove("is-active")
                Turbo.visit(location.toString())
              })
            document.querySelector("#gerarPagamento").textContent = "Gerar!"
          }, 300)
        })
        .catch(function (error) {
          Swal.fire({ title: "Erro", text: error.message, icon: "error", confirmButtonText: "OK" })
        })
    })

    document.querySelector("#fecharTelaPagamento").addEventListener("click", () => {
      document.querySelector(".modal").classList.remove("is-active")
    })
  }
}
